import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import Loader from 'react-loader-spinner';
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import moment from 'moment'
import { baseUrl } from '../../../config';
import axiosIntance from '../../../helper/axios';
import { checkAccess, FEATURES } from '../../../library/auth'
import { clickColor, inArray } from '../../../library/util';
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';

function VipRevenue() {

  const history = useHistory();
  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null ||
      !checkAccess(FEATURES.vip_report)) {
    history.push('/')
  }

  const [reportData,setReportData]=useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedrowList,setSelectedRowList]=useState([]);
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date(Date.now()).setHours(23,59,0,0));
  const [message, setMessage] = useState('')
  const [loader,setLoader]=useState(false)

  // fields with dynamic titles
  const [title_projected_rebill_revenue,setTitleProjectedRebillRevenue]=useState('Projected Rebill Revenue');
  const [title_estimated_rebill_net_revenue,setTitleEstimatedBillableRevenue]=useState('Estimated Rebill Net Revenue');

  useEffect(() => {
    return () => {
      console.log('un subscribe')
    }
  }, [])

  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const handleSelectRow = (selectedRow) => {
    if (!inArray(selectedRow.tableData.id, selectedrowList)) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  const handleRunReport = () => {
    setMessage('');

    if (startDate == null) {
      setMessage('Date must not be blank')
      return false;
    }

    setLoader(true);

    axiosIntance.get(`${baseUrl}/reports/vip/revenue`
      + `?startdate=${moment(startDate).format('YYYY-MM-DD HH:mm:ss')}`
      + `&enddate=${moment(endDate).format('YYYY-MM-DD HH:mm:ss')}`
    , {}).then(response => {
      setLoader(false);
      if (response.data.result.length > 0) {
        setTitleProjectedRebillRevenue(`Projected Rebill Revenue ${response.data.result[0].projected_rebill_revenue_note}`);
        setTitleEstimatedBillableRevenue(`Estimated Rebill Net Revenue ${response.data.result[0].projected_rebill_revenue_note}`);
        setReportData(response.data.result);
      } else {
        setTitleProjectedRebillRevenue('Projected Rebill Revenue');
        setTitleEstimatedBillableRevenue('Estimated Rebill Net Revenue');
        setReportData([]);
      }
    }).catch(error => {
      setLoader(false);
      setMessage('Something went wrong');
    });
  }

  const handleResetFilter = () => {
    setMessage('');
    setEndDate(new Date(Date.now()));
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setReportData([]);
  }

  const renderPercent = field => data => 
    data[field] !== undefined ? `${(100 * data[field]).toFixed(1)}%`  : '';

  const renderCurrency = field => data => 
    data[field] !== undefined ? `$${data[field].toFixed(2)}`  : '';

  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='errorMsg'>{message}</div>

      <section id="content-wrapper">
        <label>Start Date</label>
        <label className='endDateStyle'>End Date</label>
        <div className="input-bar">
          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={startDate}
              className='width140x'
              onChange={(date) => setStartDate(date)}
              placeholder='Start Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}
            />

          </div>

          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={endDate}
              className='width140x'
              onChange={(date) => setEndDate(date)}
              placeholder='End Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}

            />

          </div>
          &nbsp;&nbsp;&nbsp;
        
          <div className="input-bar-item">
            <button type="button" onClick={handleRunReport} className="btn btn-primary">Run Report</button>
          </div>

          <div className='input-bar-item'>
            <button type="button" onClick={handleResetFilter} className="btn btn-primary">Reset</button>
          </div>

        </div>

        {loader

          ? <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" />
          </div>
          
          : <MaterialTable
            onRowClick={((evt, selectedRow) => handleSelectRow(selectedRow))}

            columns={[
              { title: "Group", field: "group" },
              
              { title: "FE Sales", field: "fe_sales" },
              { title: "FE Declines", field: "fe_declines" },
              { title: "Sales Total", field: "revenue", render: renderCurrency('revenue') },
              { title: "AOV", field: "aov", render: renderCurrency('aov') },
              { title: "AOV (Net)", field: "net_aov", render: renderCurrency('net_aov') },

              { title: "Initial Sales", field: "initial_sales" },
              { title: "Declines", field: "initial_declines" },
              { title: "Decline % of Initial Sales", field: "initial_declines_perc", render: renderPercent('initial_declines_perc') },
              { title: "New VIPs", field: "initial_vip_sales" },
              { title: "Opt in to VIP", field: "initial_vip_sales_perc", render: renderPercent('initial_vip_sales_perc') },

              { title: "Rebills", field: "rebill_sales" },
              { title: "Rebill Revenue", field: "rebill_revenue", render: renderCurrency('rebill_revenue') },
              { title: "Rebill Approval %", field: "rebill_approval_perc", render: renderPercent('rebill_approval_perc') },
              { title: "Rebill Refunds #", field: "rebill_refunds" },
              { title: "Rebill Refunds $", field: "rebill_refund_amount", render: renderCurrency('rebill_refund_amount') },
              { title: "Rebill Refunded %", field: "rebill_refund_amount_perc", render: renderPercent('rebill_refund_amount_perc') },
              { title: "Rebill Chargebacks #", field: "rebill_chargebacks" },
              { title: "Rebill Chargebacks $", field: "rebill_chargeback_amount", render: renderCurrency('rebill_chargeback_amount') },
              { title: "Rebill Net Revenue $", field: "rebill_net_revenue", render: renderCurrency('rebill_net_revenue') },
              
              { title: "FE Refunds #", field: "fe_refunds" },
              { title: "FE Refunds %", field: "fe_refunds_perc", render: renderPercent('fe_refunds_perc') },
              { title: "FE Refunds $", field: "fe_refund_amount", render: renderCurrency('fe_refund_amount') },              
              { title: "FE Chargebacks #", field: "fe_chargebacks" },
              { title: "FE Chargebacks $", field: "fe_chargeback_amount", render: renderCurrency('fe_chargeback_amount') },

              { title: "Initial Sale Refunds #", field: "initial_refunds" },
              { title: "Initial Sale Refunds %", field: "initial_refunds_perc", render: renderPercent('initial_refunds_perc') },
              { title: "Initial Sale Refunds $", field: "initial_refund_amount", render: renderCurrency('initial_refund_amount') },
              { title: "Initial Sale Chargebacks #", field: "initial_chargebacks" },
              { title: "Initial Sale Chargebacks %", field: "initial_chargebacks_perc", render: renderPercent('initial_chargebacks_perc') },
              { title: "Initial Sale Chargebacks $", field: "initial_chargeback_amount", render: renderCurrency('initial_chargeback_amount') },

              { title: "VIP Sale Refunds #", field: "initial_vip_refunds" },
              { title: "VIP Sale Refunds %", field: "initial_vip_refunds_perc", render: renderPercent('initial_vip_refunds_perc') },
              { title: "VIP Sale Chargebacks #", field: "initial_vip_chargebacks" },
              { title: "VIP Sale Chargebacks %", field: "initial_vip_chargebacks_perc", render: renderPercent('initial_vip_chargebacks_perc') },

              { title: "VIP Cancellations", field: "cancelled_vips" },
              { title: "Active VIPs", field: "active_vips" },
              { title: "In Recycle VIPs", field: "in_recycle_vips" },

              { title: title_projected_rebill_revenue, field: "projected_rebill_revenue", render: renderCurrency('projected_rebill_revenue') },
              { title: title_estimated_rebill_net_revenue, field: "estimated_rebill_net_revenue", render: renderCurrency('estimated_rebill_net_revenue') },
              { title: "Projected Rebill Revenue Next 30 Days", field: "projected_rebill_revenue_next_30_days", render: renderCurrency('projected_rebill_revenue_next_30_days') },
              { title: "Projected Rebill Net Revenue Next 30 Days", field: "projected_rebill_net_revenue_next_30_days", render: renderCurrency('projected_rebill_net_revenue_next_30_days') },
            ]}

            data={reportData}

            parentChildData={(row, rows) => rows.find(r => r.key === row.parentKey)}

            title="VIP Revenue"

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              maxBodyHeight: '560px',
              paging: false,
              exportButton: true,
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : '',
                fontWeight: (rowData.group === 'Total' ? 'bold' : 'inherit')
              })
            }}
          />
        }

      </section>

    </div>
  );
}

export default VipRevenue
